<template>
  <v-footer class="pt-6 pt-md-16 pb-0 d-flex flex-column" color="surface-light">
    <v-row class="w-75">
      <v-col
        cols="12"
        lg="3"
        md="12"
        class="d-flex flex-column align-center"
      >

        <svg-logo-text width="100%" />

        <p class="text-body-small">Pentest reporting easy as pie.</p>

        <div class="mt-3">
          <v-btn
            key="mdi-github"
            icon="mdi-github"
            size="large"
            variant="text"
            href="https://github.com/Syslifters/sysreptor"
            target="_blank"
          />
          <v-btn
            key="mdi-linkedin"
            icon="mdi-linkedin"
            size="large"
            variant="text"
            href="https://www.linkedin.com/showcase/sysreptor/"
            target="_blank"
          />
          <v-btn
            key="x-logo"
            size="large"
            variant="text"
            href="https://x.com/sysreptor"
            target="_blank"
            icon
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
          </v-btn>
        </div>

        
        <img :src="theme.current.value.dark ? MadeAndHostedInEuropeDark : MadeAndHostedInEurope" alt="MadeAndHostedInEurope" class="mt-4" width="150" />
      </v-col>

      <v-col
        v-for="(section, i) in sections"
        :key="i"
        cols="12"
        lg="3"
        md="6"
      >
        <p class="text-body-large font-weight-bold mb-3">{{ section.title }}</p>

        <div
          v-for="item in section.items"
          :key="item.text"
        >
          <v-btn
            class="text-none px-0 justify-start footer-link"
            exact
            :href="item.href"
            :to="item.to"
            :ripple="false"
            :text="item.text"
            :target="item.href ? '_blank' : undefined"
            :rel="item.href ? 'noopener noreferrer' : undefined"
            :append-icon="item.href ? 'mdi-open-in-new' : undefined"
            variant="plain"
          />
        </div>
      </v-col>
    </v-row>
    <v-divider class="my-6" />
  </v-footer>
</template>

<script setup>
import MadeAndHostedInEurope from '@/public/static/europe/made_and_hosted_in_europe.svg'
import MadeAndHostedInEuropeDark from '@/public/static/europe/made_and_hosted_in_europe_dark.svg'

const theme = useTheme()

const sections = [
  {
    title: 'SysReptor',
    items: [
      { text: 'Get a license', to: '/get-license' },
      { text: 'Pricing', to: '/pricing' },
      { text: 'Documentation', href: 'https://docs.sysreptor.com/' },
      { text: 'Self-hosted FAQs', href: 'https://docs.sysreptor.com/faq/self-hosted' },
      { text: 'Cloud FAQs', href: 'https://docs.sysreptor.com/faq/cloud' },
      { text: 'Application FAQs', href: 'https://docs.sysreptor.com/faq/application' },
      { text: 'Try the playground', href: '/demo/' },
    ],
  },
  {
    title: 'Community',
    items: [
      { text: 'Report a bug', href: 'https://github.com/Syslifters/sysreptor/issues/new?labels=bug' },
      { text: 'Request a feature ', href: 'https://github.com/Syslifters/sysreptor/issues/new?labels=enhancement' },
      { text: 'Ask a question', href: 'https://github.com/Syslifters/sysreptor/discussions/categories/q-a' },
      { text: 'Report a security issue', href: 'https://github.com/Syslifters/sysreptor/security' },
    ],
  },
  {
    title: 'Legal',
    items: [
      { text: 'Privacy Notice', to: '/data-privacy' },
      { text: 'Contact us', href: 'https://docs.sysreptor.com/contact-us/#contact-information' },
      { text: 'Terms of Service (Cloud)', href: '/api/v1/documents/latest?type=order-cloud-tos' },
      { text: 'Terms of Service (Self-Hosted)', href: '/api/v1/documents/latest?type=order-sh-tos' },
      { text: 'Imprint', href: 'https://www.syslifters.com/en/imprint' },
    ],
  },
]
</script>

<style lang="scss" scoped>

.footer-link :deep(.v-btn__append) {
  font-size: 10px;
}

.footer-link,
.footer-link:visited,
.v-btn,
.v-btn:visited {
  color: rgb(var(--v-theme-primary));
  font-weight: 500;
  opacity: 1;
}
</style>
